import { format } from 'date-fns'

interface InfoCardProps {
  clientInfo: {
    num_client: number
    denomination: string
    firstname: string
    lastname: string
    adresse: string
    codePostal: string
    localite: string
    pays: string
    mobile: string
    email: string
    depot: string
    dateFermeture: string | null
    siret: string
    createdAt: string
    updatedAt: string
  } | null
}

const InfoCard: React.FC<InfoCardProps> = ({ clientInfo }) => {
  if (!clientInfo) {
    return <div>Pas d'informations disponibles</div>
  }
  const creationDate = format(new Date(clientInfo.createdAt), 'dd/MM/yyyy')
  const infos = [
    { label: 'Numéro Client', value: clientInfo.num_client },
    { label: 'Nom', value: clientInfo.firstname },
    { label: 'Prénom', value: clientInfo.lastname },
    { label: 'Numéro de téléphone', value: clientInfo.mobile },
    { label: 'Dépôt', value: clientInfo.depot },
    { label: 'Raison Sociale', value: clientInfo.denomination },
    { label: 'Date de création', value: creationDate },
  ]

  return (
    <div className="w-3/5 mx-auto bg-white shadow-md p-6 pt-0">
      <div className="flex flex-col items-center justify-center w-full mb-0" id="inscription">
        <h2 className="flex items-center justify-center">Informations client</h2>
      </div>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
        {infos.map((info, index) => (
          <li key={index} className="text-black">
            <span>
              {info.label} : {info.value}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default InfoCard
